import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibFakeInput',
  props: {
    // clearable: {
    //   type: Boolean
    // },
    // label: {
    //   type: String
    // },
    value: {
      type: [String, Number],
      default: ''
    }
  }
};